/* eslint-disable import/prefer-default-export, max-len */
import * as cssVarsMarketingContent from '../sass/pages/landing-page/_marketing-content.scss';
import * as cssVarsCommon from '../sass/_variables.scss';

// DEFAULT SETTINGS FOR UI_CUSTOMIZATION FEATURE
export const DEFAULT_SETTINGS = {
    typography: {
        customFontSelected: false,
        predefinedFont: 'Open Sans',
        hyperlinkColor: '#1FAFF3',
        hyperlinkHoverColor: '#0065e3',
        primaryTextColor: '#5B6372',
        secondaryTextColor: '#9EA2AB',
        fontFamily: 'Open Sans',
    },
    general: {
        brandColor: '#ffcb05',
        primaryButtonBaseColor: '#ffcb05',
        primaryButtonHoverColor: '#f2b900',
        primaryButtonTextColor: '#3a4356',
        secondaryButtonBaseColor: '#edeef1',
        secondaryButtonHoverColor: '#d0d3db',
        secondaryButtonTextColor: '#3a4356',
        backgroundColor: '#ffffff',
    },
    dashboards: {
        toolbarBackgroundColor: '#fff',
        toolbarSecondaryTextColor: '#9EA2AB',
        toolbarTextColor: '#5B6372',
        colorPaletteName: 'Vivid',
        navBackgroundColor: '#fff',
        navTextColor: '#5B6372',
        navTextHoverColor: '#3A4356',
        navHoverBackgroundColor: '#F4F4F8',
        panelBackgroundColor: '#F6F6F6',
        panelTitleTextColor: '#5B6372',
        widgetTextColor: '#5B6372',
        widgetSecondaryTextColor: '#9EA2AB',
        widgetBackgroundColor: '#FFFFFF',
        widgetTitleBackgroundColor: '#FFFFFF',
        widgetTitleColor: '#5B6372',
        widgetTitleAlignment: 'left',
        widgetSecondaryTitleColor: '#9EA2AB',
        widgetTitleDividerEnabled: false,
        widgetTitleDividerColor: '#5B6372',
        widgetBorderEnabled: false,
        widgetBorderColor: '#9EA2AB',
        widgetCornerRadius: 'none',
        widgetShadow: 'none',
        widgetSpacing: 'none',
        layoutBackgroundColor: '#FFFFFF',
        filterBoxBackgroundColor: '#ffffff',
        filterBoxPrimaryTextColor: '#5B6372',
        filterBoxSecondaryTextColor: '#9EA2AB',
    },
};

export const CSS_VARS = {
    marketingContentLeftBackgroundColor: cssVarsMarketingContent.marketingContentLeftBackgroundColor,
    loginDarkColor: cssVarsCommon.loginDarkColor,
    darkBtnHoverColor: cssVarsCommon.darkBtnHoverColor,
    greyHoverColor: cssVarsCommon.greyHoverColor,
    defaultBackgroundColor: cssVarsCommon.defaultBackgroundColor,
};

export const SLF_FULL = {
    // FONTS
    TEXT_PRIMARY: {
        class: 'slf-text-primary',
        description: 'Used for primary text if needed. Affects only color; By default all the text is primary',
    },
    TEXT_SECONDARY: {
        class: 'slf-text-secondary',
        description: 'Used for secondary text (the grey one by default). Affects only color',
    },
    TEXT_SECONDARY_HOVER: {
        class: 'slf-text-secondary-hov',
        description: 'Used for secondary text that should become primary on hover. Affects only color',
    },
    TEXT_HREF: {
        class: 'slf-text-href',
        description: 'Used for hyperlinks-like text (the blue one). Affects only color. Also affects hover color',
    },
    TEXT_HREF_HOVER: {
        class: 'slf-text-href-hov',
        description: 'Just an alias for slf-text-href',
    },
    WIDGET_BACK: {
        class: 'slf-widget-back',
        description: 'Widget background color',
    },
    WIDGET_TITLE_BACK: {
        class: 'slf-widget-title-back',
        description: 'Widget title background color',
    },
    WIDGET_BACK_SECONDARY: {
        class: 'slf-widget-back-secondary',
        description: 'Widget secondary background color. Dynamically calculated to be "slightly different" from general widget back color',
    },
    WIDGET_TEXT_PRIMARY: {
        class: 'slf-widget-text-primary',
        description: 'Widget primary text color',
    },
    WIDGET_TEXT_PRIMARY_HOV: {
        class: 'slf-widget-text-primary-hov',
        description: 'Widget primary text color that should become secondary on hover',
    },
    WIDGET_TEXT_SECONDARY: {
        class: 'slf-widget-text-secondary',
        description: 'Widget secondary text',
    },
    WIDGET_TEXT_SECONDARY_HOV: {
        class: 'slf-widget-text-secondary-hov',
        description: 'Widget secondary text that should become primary on hover',
    },
    BACK: {
        class: 'slf-back',
        description: 'General background color (white by default)',
    },
    BACK_HOV: {
        class: 'slf-back-hov',
        description: 'General background color (white by default) that should change color ( Grey by default) on hover',
    },
    BACK_HOV_LIGHT: {
        class: 'slf-back-hov-light',
        description: 'General background color (white by default) that should change color a bit (light grey by default) on hover',
    },
    BACK_SECONDARY: {
        class: 'slf-back-secondary',
        description: 'Secondary background color (calculated to be a bit different from general back)',
    },
    BACK_SECONDARY_OR_DEFAULT: {
        class: 'slf-back-secondary-or-default',
        description: 'Secondary background color (calculated to be a bit different from general back), or became white if default background is selected',
    },
    BACK_SECONDARY_HOV: {
        class: 'slf-back-secondary-hov',
        description: 'Secondary background color that should change color a bit on hover',
    },
    DEFAULT: {
        class: 'slf-default',
        description: 'Everything inside this selector will have default style (default colors)',
    },
};

export const SLF = Object.keys(SLF_FULL)
    .reduce((acc, key) => ({
        ...acc,
        [key]: SLF_FULL[key].class,
    }), {});

export const SLF_SEL = Object.keys(SLF_FULL)
    .reduce((acc, key) => ({
        ...acc,
        [key]: `.${SLF_FULL[key].class}`,
    }), {});

export const MAIN_LAYOUT_SELECTORS = '.prism-window, .main-container, .layout__header-block, .acc-win';
